import { BookingIntegrated } from '@modules/Booking/components/BookingIntegrated';
import { LoaderCentered } from '@modules/components';
import NotFoundView from '@modules/components/NotFoundView';
import { useUserCanCreateCampaignInBooking } from '@modules/permissions';

export default function BookingNewCampaign() {
  const { isAllowed: canCreateCampaignInBooking, loading } =
    useUserCanCreateCampaignInBooking();

  if (loading) {
    return <LoaderCentered />;
  }
  // booking has special validations to be enabled for the user
  // that consists of more than just checking for permission for a single resource
  // so it cannot be simply checked in the router config
  if (!canCreateCampaignInBooking) {
    return <NotFoundView />;
  }

  return <BookingIntegrated mode="BOOKING" />;
}
